import(/* webpackMode: "eager" */ "/app/apps/ashtrom-ashdar/app/[locale]/(layout)/not-found.tsx");
